export default {
    event_delete_title: "Delete Event",
    event_delete_success_message: "The event has been removed",
    event_delete_message: "Are you sure you want to remove the event?",
}